import React from "react";

export type BadgeTone = "green" | "gray" | "orange" | "red" | "blue";

const toneClasses: Record<BadgeTone, string> = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  gray: "bg-gray-100 text-gray-600 border-gray-200",
  orange: "bg-orange-50 text-orange-600 border-orange-200",
  red: "bg-red-10 text-red border-red-100",
  blue: "bg-sky-50 text-sky-700 border-sky-200",
};

interface BadgeChipProps {
  tone?: BadgeTone;
  children: React.ReactNode;
  className?: string;
}

export function BadgeChip({ tone = "gray", children, className }: BadgeChipProps) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${
        toneClasses[tone]
      } ${className ?? ""}`}
    >
      {children}
    </span>
  );
}
